import { Linking, Platform } from 'react-native';

import { ActionButtonVariants } from 'components/action-button';
import { primitive } from 'styles/constants';
import { getConfigValue } from 'utils/environment';

import { LaunchDarklyFlag, useFlag } from '../../../../state/launchdarkly';

import { CartDebugActionButton } from './cart-debug-action-button';

const buildSanityLink = (id: string, sanityProjectId: string) => {
  const env = getConfigValue({ key: 'env' });
  const region = getConfigValue({ key: 'country' });
  const query = `*%5B_id%3D%3D%22${id}%22%5D%0A&perspective=published`;
  return `https://${sanityProjectId}.api.sanity.io/vX/data/query/${env}_bk_${region.toLocaleLowerCase()}?query=${query}`;
};

const openExternalURL = (url: string) => {
  if (Platform.OS === 'web') {
    window.open(url, '_blank'); // Opens in a new tab on web
  } else {
    Linking.openURL(url); // Opens in the default browser on iOS/Android
  }
};

export const CartSanityButton = ({ id }: { id: string }) => {
  const sanityProjectId = useFlag(LaunchDarklyFlag.SANITY_PROJECT_ID) as string;

  return (
    <CartDebugActionButton
      background={primitive.$blackOpacity10}
      variant={ActionButtonVariants.TEXT_ONLY}
      onPress={() => openExternalURL(buildSanityLink(id, sanityProjectId))}
    >
      sanity ➚
    </CartDebugActionButton>
  );
};
